<div class="progress">
    <div class="progress-bar" role="progressbar" [style]="'width: ' + width+'; background-color: '+ background"  aria-valuemin="0" aria-valuemax="100">{{width}}</div>
</div>